<template>
  <div>
    <h2 class="margin-t-8">
      {{ subHeader }}
    </h2>
    <p class="margin-t-4">
      {{ body }}
      <a :href="`tel:${supportNumber}`">
        {{ formattedSupportNumber }}
      </a>
    </p>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'
import authStore from '@/store/modules/auth'
import { phoneFormatFilterInternational, getSupportNumber } from '@/utils/phone'
import tripModification from '@/store/modules/tripModification'

@Component({})
export default class TripModificationError extends Vue {

  get supportNumber(): string {
    return getSupportNumber(authStore.customer.isElite)
  }

  get formattedSupportNumber(): string {
    return `${phoneFormatFilterInternational(this.supportNumber)}`
  }

  get isDraftInProgress(): boolean {
    return tripModification.isDraftInProgress
  }

  get subHeader(): string {
    return this.isDraftInProgress ? 'A Customer Support representative started a modification request for this trip.' : 'We were not able to submit your trip modification request online.'
  }

  get body(): string {
    return this.isDraftInProgress ? 'To continue this request or for further help, call Customer Support at' : 'To modify your booking, please call our customer support service at'
  }
}
</script>
